let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: 'ZD-BOX编号',
    props: 'snCode',
    minWidth: 180,
  },

  {
    label: 'PCS-SN',
    props: 'pcsSnCode',
    minWidth: 180,
    tooltip: true,
  },
  {
    label: '型号名称',
    props: 'typeName',
    minWidth: 200,
  },
  {
    label: '所属充电网点',
    props: 'stationName',
    minWidth: 120,
    // sortable: true,
  },
  {
    label: '状态',
    props: 'batteryStatus',
    minWidth: 160,
    // sortable: true,
  },
  {
    label: '储能电池数量',
    props: 'batteryCount',
    minWidth: 160,
    tooltip: true,
  },
  {
    label: '储能电池总容量',
    props: 'batteryCapacity',
    minWidth: 160,
    tooltip: true,
  },
  {
    label: '总SOC',
    props: 'batterySoc',
    minWidth: 160,
    tooltip: true,
  },
  {
    label: '当前可充电量',
    props: 'batteryCanChargeDegree',
    minWidth: 200,
  },
  {
    label: '当前可放电量',
    props: 'batteryCanDischargeDegree',
    minWidth: 120,
  },
];

// 面包屑
pageConfig.listBreadCrumb = [
  {
    type: 'title',
    name: '首页',
  },
  {
    type: 'title',
    name: '充电管理'
  },
  {
    type: 'title',
    name: 'zd-box管理'
  }
];

// 详情面包屑
pageConfig.detailBreadCrumb = [
  {
    type: 'title',
    name: '首页',
  },
  {
    type: 'title',
    name: '充电管理'
  },
  {
    type: "router",
    name: 'zd-box管理',
    router: "ZDBoxManage"
  },
  {
    type: "title",
    name: "详情信息"
  }
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: false,
};

// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "energyPointId",
  editRouter: "ZDBoxDetail"
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
}

export default pageConfig;
